export default __webpack_public_path__ + "static/media/developer-get-in-touch.bb504831.svg";